import apiConfig from '@/api/api'

const { api } = apiConfig()

const address = {
  namespaced: true,
  state: () => ({
    countries: [],
    states: [],
    LGAs: []
  }),

  getters: {
    _countries: state => state.countries,
    _states: state => state.states,
    _LGAs: state => state.LGAs
  },

  mutations: {
    COUNTRIES (state, data) {
      state.countries = data
    },
    STATES (state, data) {
      state.states = data
    },
    LGAS (state, data) {
      state.LGAs = data
    }
  },

  actions: {
    GetCountries ({ commit }) {
      return new Promise((resolve, reject) => {
        api.get('/Address/GetCountries')
          .then(response => response.data)
          .then(response => {
            commit('COUNTRIES', response.data)

            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    GetStates ({ commit }) {
      return new Promise((resolve, reject) => {
        api.get('/Address/GetStates')
          .then(response => response.data)
          .then(response => {
            commit('STATES', response.data)

            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    GetLGAs ({ commit }, stateId) {
      return new Promise((resolve, reject) => {
        api.get(`/Address/GetLGAs?StateId=${stateId}`)
          .then(response => response.data)
          .then(response => {
            commit('LGAS', response.data)

            resolve(response)
          })
          .catch(error => reject(error))
      })
    }
  }
}

export default address
